import React, {useEffect} from 'react';
import {Link, useHistory} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {Controller, useForm} from 'react-hook-form';
import * as yup from 'yup';
import {yupResolver} from '@hookform/resolvers/yup';
import {authPath, rootMainPath} from '../../../routes/paths';
import {postPassRecovery} from '../../../redux/actions/auth/authActions';
import InputMUI from '../../../shared/InputMUI';
import ButtonMUI from '../../../shared/ButtonMUI';
import EmailIcon from '../../../assets/icons/email.svg';
import passwordBg from '../../../assets/images/auth/password-img.jpg';
import passMob from '../../../assets/images/auth/pass-mob.jpg';
import Social from '../Social';
import IconButtonMUI from '../../../shared/IconButtonMUI';
import {ReactComponent as BackIcon} from '../../../assets/icons/back.svg';
import {useTranslation} from 'react-i18next';

const PassRecovery = () => {
  const {t} = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const {buttonLoading} = useSelector(({app}) => app);

  useEffect(() => {
    localStorage.getItem('token') && history.push(rootMainPath);
  }, []);

  const schema = yup.object({
    email: yup.string().email(t('validations.email')).required(t('validations.required'))
  });

  const {
    control,
    handleSubmit,
    formState: {errors, isValid, isSubmitting}
  } = useForm({
    mode: 'all',
    reValidateMode: 'onChange',
    shouldFocusError: true,
    resolver: yupResolver(schema),
    defaultValues: {
      email: ''
    }
  });

  const onSubmit = async (data) => {
    try {
      const res = await dispatch(postPassRecovery(data));
      if (res.payload && res.payload.status && res.payload.status === 200) {
        history.push(authPath.successfullyRecovery);
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className='auth-page__content'>
      <div className='auth-page__bg'>
        <img className='employee' src={passwordBg} alt='AuthBg' />
      </div>
      <div className='auth-box__wrapper'>
        <div />
        <form className='auth-box' onSubmit={handleSubmit(onSubmit)}>
          <div className='auth-box__head'>
            <div className='auth-box__mini-icon'>
              <img src={passMob} alt='images' />
            </div>

            <div className='auth-box__back'>
              <div className='auth-box__back-icons'>
                <IconButtonMUI color='primary' component={Link} to={authPath.signIn}>
                  <BackIcon />
                </IconButtonMUI>
              </div>
              <div className='auth-box__back-text'>{t('auth.signIn')}</div>
            </div>

            <div className='auth-box__subtitle'>{t('auth.forgotPassword')}</div>
            <div className='auth-box__descriptions'>{t('auth.sendEmail')}</div>
          </div>

          <div className='auth-box__input_wrapper'>
            <div className='auth-box__input_box'>
              <Controller
                name='email'
                control={control}
                render={({field}) => (
                  <InputMUI
                    className='auth-box__input'
                    type='email'
                    fullWidth
                    error={errors.email?.message}
                    inputProps={field}
                    label={t('auth.emailLabel')}
                    startAdornment={EmailIcon}
                  />
                )}
              />
              <span className='input-info'>{t('auth.enterEmail')}</span>
            </div>
            <ButtonMUI disabled={!isValid || buttonLoading} loading={isSubmitting} formAction>
              {t('auth.submit')}
            </ButtonMUI>
          </div>

          <div className='auth-box__info-text'>
            <div className='text'>{t('auth.orAuthorize')}</div>
          </div>

          <Social />
        </form>

        <div className='auth-box__subscribe'>{t('SideBgFooter.copyright', {year: new Date().getFullYear()})}</div>
      </div>
    </div>
  );
};

export default PassRecovery;
